export default __webpack_public_path__ + "static/media/step2-5.99b5cf32.jpg";